import { PATHS } from '../config';
import { dynoape, dynoapeAPI } from '../dynoape';
import type { CreateOrgUserRequest, OrgUser } from './Models';

const getOrgUsers = async (orgId: string): Promise<OrgUser[]> => {
    const response = await dynoape.get(PATHS.orgUsers(orgId));
    const body = response?.data?.body;
    return body?.elements ?? body?.body?.elements ?? [];
};

const createOrgUser = async (
    orgId: string,
    request: CreateOrgUserRequest,
): Promise<OrgUser> =>
    await dynoapeAPI.post(PATHS.orgUserCreate(orgId), request);

const deleteOrgUser = async (orgId: string, userId: string): Promise<void> =>
    await dynoapeAPI.delete(PATHS.orgUser(orgId, userId));

const OrgUserService = { getOrgUsers, createOrgUser, deleteOrgUser };

export default OrgUserService;
